<div class="outline-none flex py-2 text-primary cursor-default">
  <fa-icon class="text-lg " [icon]="faIcon"></fa-icon>
  <div class="ml-2 mr-1 flex items-center  font-medium ">{{link}}</div>
  <fa-icon [copy-clipboard]="link" class="text-lg pl-2 text-gray-600  cursor-pointer" [icon]="faCopy"></fa-icon>
</div>